export const isMac = () => navigator.userAgent.indexOf('Mac OS X') !== -1;